import React, {Component} from 'react';
import {NavLink, Route, Switch} from "react-router-dom";

import Gallery from "./Gallery";
import FactsForTheVisitor from "./FactsForTheVisitor";

import landing from '../../../resources/images/riad/landing_2.jpg';
import room from '../../../resources/images/riad/room_14.jpg';
import coast from '../../../resources/images/essaouira/image4.jpg';
import town from '../../../resources/images/essaouira/image5.jpg';
import ImageList from "../../components/ImageList";

const images = [
    {
        img: landing,
        title: "AA",
        author: "BB",
        cols: 2,
    },
    {
        img: town,
        title: "AA",
        author: "BB",
        cols: 2
    },
    {
        img: coast,
        title: "AA",
        author: "BB",
        cols: 2
    },
    {
        img: room,
        title: "AA",
        author: "BB",
        cols: 2
    }
];


class Overview extends Component {

    renderPage = () => {
        return (
            <div className={"info-split-wrap"}>
                <div className={"half_width left_half"}>
                    <p className={"info_text"}>Riad Remmy is a small romantic boutique guest riad, located in
                        Essaouira - Morocco.
                    </p>
                    <p className={"info_text"}>Hidden within the walls of the medina, Riad Remmy is an oasis of calm
                        amid the hustle and bustle of the old town. Designed to be in harmony with its surroundings,
                        built and internally designed using the many skills of the local craftsmen, we know you will
                        appreciate the unique atmosphere we have created for you.
                    </p>
                    <p className={"info_text"}>Riad Remmy has five beautiful traditionally-styled en-suite bedrooms
                        available. Unwind and relax with on our roof terrace or explore the markets
                        and festivals of the medina, the choice is yours.
                    </p>

                    <table className={"even_spaced_table"}>
                        <thead>
                        <tr>
                            <td>
                                <NavLink className={"page_link"} to={"/overview/gallery"}><h3>Gallery</h3></NavLink>
                            </td>
                            <td>
                                <NavLink className={"page_link"} to={"/overview/facts"}><h3>Facts for the Visitor</h3></NavLink>
                            </td>
                        </tr>
                        </thead>
                    </table>
                </div>
                <div className={"half_width right_half"}>
                    <ImageList images={images}/>
                </div>
            </div>
        );
    };

    render() {
        return (
            <React.Fragment>
                <Switch>
                    <Route path={"/overview"} exact={true} render={() => this.renderPage()}/>
                    <Route path={"/overview/gallery"} render={() => <Gallery/>}/>
                    <Route path={"/overview/facts"} render={() => <FactsForTheVisitor/>}/>
                </Switch>
            </React.Fragment>
        );
    }
}

export default Overview
